import { ClassBuilderPlaceholderResolver } from '@/tools/views/class-admin/views/builder-placeholder/class-builder-placeholder.resolver';
import ClassAdminView from './views/admin/class-admin.view.vue';
import ClassScheduleView from './views/schedule/class-schedule.view.vue';
import ClassBuilderView from './views/builder/class-builder.view.vue';
import ClassBuilderPlaceholder from './views/builder-placeholder/class-builder-placeholder.view.vue';
import EdClassInactiveView from './views/inactive/class-inactive.view.vue';

export const ClassAdminBaseRoutes = [
  {
    name: 'class-admin',
    path: '/',
    redirect: { 
      name: 'admin'
    }
  },
  { 
    name: 'admin',
    path: 'admin',
    component: ClassAdminView
  },
  {
    name: 'schedule',
    path: ':classId/schedule',
    component: ClassScheduleView
  },
  {
    name: 'builder',
    path: ':classId/builder',
    component: ClassBuilderView
  },
  {
    name: 'builder-placeholder',
    path: ':classId/builder/placeholder/:placeholderId/calendar',
    component: ClassBuilderPlaceholder,
    beforeEnter: ClassBuilderPlaceholderResolver,
  },
  {
    name: 'inactive-classes',
    path: 'inactive-classes',
    component: EdClassInactiveView
  },
]